import { Dialog, DialogContent, DialogTitle, IconButton, Slide, Stack, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "src/components/ui/svgIcon/CloseIcon";
import { BaseBTN } from "src/components/ui";
import { useTheme } from "@emotion/react";
import Cookies from "js-cookie";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const GuideUsingSmartServicePortalDialog = ({ openRegister, onCloseRegister }) => {
  const theme = useTheme();

  return (
    <Dialog
      sx={{
        textAlign: "center",
        margin: "0 auto",
        "& div.MuiPaper-root": {
          maxWidth: "80%",
        },
      }}
      open={openRegister}
      TransitionComponent={Transition}
      keepMounted
      onClose={onCloseRegister}
    >
      <DialogTitle textAlign="center" variant="h6" color="primary">
        ثبت‌‌نام در سامانه زنجیره ارزش آبزیان{" "}
        {onCloseRegister ? (
          <IconButton
            aria-label="close"
            onClick={onCloseRegister}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon color={theme.palette.grey.gm} />
          </IconButton>
        ) : null}
      </DialogTitle>
      <Stack textAlign="right">
        <Typography variant="subtitle2" color="text.primary" textAlign="left" pt={2} px={4}>
          با توجه به اینکه کلیه اطلاعات هویتی و تماس مربوط به شما از پنجره ملی خدمات دولت هوشمند دریافت می‌گردد و قابل
          ویرایش نیست، لطفاً نسبت به تکمیل اطلاعات خود در سامانه پنجره ملی خدمات هوشمند اقدام نمایید.
        </Typography>
      </Stack>
      <Stack pt={2}> </Stack>
      <DialogContent>
        <Stack spacing={2} p={2} bgcolor="grey.gs" sx={{ borderRadius: 2 }} mt={2}>
          <Typography variant="subtitle1" color="primary.main" textAlign="left">
            راهنمای استفاده از درگاه پنجره خدمات هوشمند
          </Typography>
          <Typography textAlign="justify">
            1- پس از انتخاب دکمه “ادامه” وارد سامانه یکپارچه ذینفعان وزارت جهاد کشاورزی می‌شوید.
          </Typography>
          <Typography textAlign="justify">
            2- ابتدا، نسبت به انتخاب گزینه حقیقی (چنانچه بصورت فردی در حوزه آبزیان فعالیت می‌کنید) و یا گزینه حقوقی
            (چنانچه تحت عنوان شرکت یا سازمان در حوزه آبزیان فعالیت می‌کنید) اقدام نموده و دکمه “ورود از دولت من” را
            انتخاب نمایید.
          </Typography>
          <Typography textAlign="justify">
            3- پس از ورود به صفحه دولت من شماره تلفن همراه خود را وارد کرده (توجه داشته باشید که سیم کارت باید به نام
            خودتان باشد) و پس از وارد کردن کد امنیتی، دکمه “ارسال رمز یکبار مصرف” را انتخاب نمایید.
          </Typography>
          <Typography textAlign="justify">4- رمز پیامک شده را وارد نموده و دکمه مربوطه را انتخاب کنید.</Typography>
          <Typography textAlign="justify">
            5- پس از برگشت از سامانه پنجره ملی خدمات دولت هوشمند، از بین سامانه‌های وزارت جهاد گزینه “سامانه زنجیره ارزش
            آبزیان” را انتخاب کنید.
          </Typography>
          <Typography textAlign="justify">
            6- پس از انتقال مجدد شما به “سامانه ارزش زنجیره آبزیان” نسبت به چک کردن اطلاعات هویتی خود اقدام کرده و
            درصورت درست بودن اطلاعات، نسبت به تکمیل اطلاعات خود اقدام نمایید.
          </Typography>
          <Typography textAlign="justify">
            7- در صورت اطمینان از اطلاعات وارد شده دکمه “ثبت نهایی” را انتخاب‌کرده تا فرآیند ثبت‌نام شما انجام شود.
          </Typography>
        </Stack>
      </DialogContent>
      <Stack textAlign="right" pt={6} px={4}>
        <Stack alignItems="center" justifyContent="center" py={2}>
          <BaseBTN
            sx={{ width: "170px" }}
            color="primary"
            variant="contained"
            onClick={() => {
              Cookies.remove("UserChoice");
              Cookies.set("UserChoice", "registration");
              window.location.href = process.env.REACT_APP_SSO_URL;
            }}
          >
            ادامه
          </BaseBTN>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default GuideUsingSmartServicePortalDialog;
